import request, {Method} from "../request";
import {AppointmentsModel} from "../Models/appointments.model";

class AppointmentsService {
    async getAppointments(date: string) {
        return request<AppointmentsModel[]>(`/appointments/my/${date}`, Method.GET);
    }

    async missedAppointments(appointmentId: number) {
        return request(`/appointments/missed/${appointmentId}`, Method.POST);
    }

    async completeAppointment(appointmentId: number) {
        return request(`/appointments/completed/${appointmentId}`, Method.POST);
    }
}

const appointmentsService = new AppointmentsService();
export default appointmentsService;